// extracted by mini-css-extract-plugin
export default {"title":"P1tJ7DqbPU","button":"Qi7godAw8C"};